<template>
  <div class="app-install-wrap">
    <img src="@/assets/img/img_menu_bi.png">
    <p>
      <span>배달비 무료!</span><br>
      모든오더로 배달비 0원의<br>
      혜택을 마음껏 누리세요
    </p>
    <div class="app-loading-info">
      앱 스토어로 이동중입니다
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      platform: '',
      appLink: '',
      storeLink: '',
      detailUrl: this.$route.query.url
    }
  },
  created () {
    this.checkMobile()
  },
  methods: {
    checkMobile () {
      const agent = navigator.userAgent.toLowerCase()
      if (agent.indexOf('android') > -1) {
        this.platform = 'android'
        this.appLink = `intent://data?url=${this.detailUrl}#Intent;scheme=modnpayorder;package=info.seeroo.modnpayorder;end`
        this.storeLink = 'https://play.google.com/store/apps/details?id=info.seeroo.modnorder&hl=ko'
      } else if (agent.indexOf('iphone') > -1 || agent.indexOf('ipad') > -1 || agent.indexOf('ipod') > -1) {
        this.platform = 'iOS'
        this.appLink = `modnpayorder://data?url=${this.detailUrl}`
        this.storeLink = 'https://apps.apple.com/kr/app/%EB%AA%A8%EB%93%A0%ED%8E%98%EC%9D%B4%EC%98%A4%EB%8D%94/id6446669341'
      } else {
        this.platform = 'other'
      }
    },
    callApp () {
      window.location.href = this.storeLink
    }
  },
  watch: {
    appLink () {
      window.location.href = this.appLink
    }
  }
}
</script>

<style scoped>
</style>
